import styled from "styled-components";
import theme from "../../../../Styles/theme";

export const Container = styled.div`
  
`;



export const AddOperacaoButton = styled.button`
  color: ${theme.colors.dark};
  &:hover {
    opacity: 0.8;
  }
`;